<script>
  import { getContext } from "svelte";

  let { height } = getContext("LayerCake");

  /** @type {[number, number] | undefined} The range of pixels that the user has brushed over. */
  export let brushPixels = undefined;
</script>

{#if brushPixels}
  <rect
    x={Math.min(brushPixels[0], brushPixels[1])}
    width={Math.abs(brushPixels[1] - brushPixels[0])}
    height={$height}
    fill="rgba(255, 255, 255, 0.1)"
    stroke="white"
    stroke-dasharray="4 4"
  />
{/if}
